import { ComponentIds } from '@inter-ikea-core/core';
import EventComponent from '../components/EventComponent';
import { PlannerEcsMultiSystem } from './System';
import { ProductType } from '../../types';
import { HideDrawerFrontComponent } from '../..';
export class AccessoryAddedSystem extends PlannerEcsMultiSystem {
    constructor(coreApi) {
        super(coreApi, 'AccessoryAddedSystem', [
            ComponentIds.SELECTED_COMPONENT_ID,
            EventComponent.id,
            ComponentIds.SOMETHING_IS_DRAGGED_COMPONENT_ID,
            ComponentIds.MOVED_TO_VALID_SNAP_POSITION_COMPONENT_ID
        ]);
        this.isDrawerExcludeLockable = (entity) => {
            const productType = this.coreApi.entities.getProductType(entity);
            return productType
                ? [
                    ProductType.PAX_DRAWER,
                    ProductType.PAX_DRAWER_FRAMED,
                    ProductType.PAX_DRAWER_FRAMED_GLASS,
                    ProductType.PAX_GLASS_DRAWER
                ].includes(productType)
                : false;
        };
        this.isDrawerInterior = (entity) => {
            const productType = this.coreApi.entities.getProductType(entity);
            return productType
                ? [ProductType.PAX_DRAWER_BOX_ASM, ProductType.PAX_DRAWER_MAT].includes(productType)
                : false;
        };
        this.getAllClippedDrawers = () => {
            const allDrawers = this.coreApi.entities.getByProductTypes([
                ProductType.PAX_DRAWER,
                ProductType.PAX_DRAWER_FRAMED,
                ProductType.PAX_DRAWER_FRAMED_GLASS,
                ProductType.PAX_GLASS_DRAWER
            ]);
            return allDrawers.filter(drawer => drawer.hasComponent(HideDrawerFrontComponent.id));
        };
        this.viewer = this.coreApi.ipexViewer;
    }
    onAdd(entity, newComponent) {
        if (newComponent.typeId === ComponentIds.SOMETHING_IS_DRAGGED_COMPONENT_ID) {
            this.disableClippingOnAllDescendants(newComponent.entity);
        }
        else if (newComponent.typeId === ComponentIds.MOVED_TO_VALID_SNAP_POSITION_COMPONENT_ID) {
            this.onMovedToValidSnapPosition(entity, newComponent);
        }
    }
    onMovedToValidSnapPosition(entity, newComponent) {
        if (this.isDrawerInterior(entity)) {
            const parentDrawer = this.getParentDrawer(newComponent);
            if (parentDrawer) {
                this.removeClippingFromAllDrawers(parentDrawer);
                this.addClipping(parentDrawer);
            }
        }
    }
    getParentDrawer(entity) {
        const host = entity.snap?.host;
        if (host && this.isDrawerExcludeLockable(host)) {
            return host;
        }
        return null;
    }
    onUpdate(entity, oldComponent, newComponent) {
        if (newComponent.typeId === EventComponent.id &&
            newComponent.event === 'selected') {
            // Remove clipping on all clipped drawers when selecting something.
            // If a user added accessories using drag and drop a drawer can get
            // clipped but not selected. So when selecting something else we need
            // to remove the clipping.
            this.removeClippingFromAllDrawers();
        }
    }
    // Fired when selecting another component or deselecting a drawer
    onRemove(entity, oldComponent) {
        if (oldComponent.typeId === ComponentIds.SELECTED_COMPONENT_ID) {
            this.removeClipping(entity);
        }
    }
    addClipping(drawer) {
        if (!drawer)
            return;
        const model = drawer.getComponent(ComponentIds.LOADED_MODEL_INFO_COMPONENT_ID);
        const entityObjectId = this.coreApi.entities.getObjectIdsByEntity(drawer);
        if (!drawer.hasComponent(HideDrawerFrontComponent.id) &&
            model?.hasFinishedLoading &&
            entityObjectId &&
            this.isDrawerExcludeLockable(drawer)) {
            drawer.addComponent(new HideDrawerFrontComponent());
        }
    }
    removeClipping(drawer) {
        if (!drawer)
            return;
        if (drawer.hasComponent(HideDrawerFrontComponent.id)) {
            drawer.removeComponent(HideDrawerFrontComponent.id);
        }
    }
    disableClippingOnAllDescendants(parentEntity) {
        this.coreApi.entities.findAllRelatedEntityIds([parentEntity]).forEach(entityId => {
            const entity = this.coreApi.getServices().sceneManager.findEntity(entityId);
            if (entity && this.isDrawerExcludeLockable(entity)) {
                this.removeClipping(entity);
            }
        });
    }
    enableClippingOnAllDescendants(parentEntity) {
        this.coreApi.entities.findAllRelatedEntityIds([parentEntity]).forEach(entityId => {
            const entity = this.coreApi.getServices().sceneManager.findEntity(entityId);
            if (entity) {
                this.addClipping(entity);
            }
        });
    }
    removeClippingFromAllDrawers(exceptEntity) {
        const allClippedDrawers = this.getAllClippedDrawers();
        if (allClippedDrawers && allClippedDrawers.length > 0) {
            allClippedDrawers.forEach(drawer => {
                if (exceptEntity?.id !== drawer.id) {
                    this.removeClipping(drawer);
                }
            });
        }
    }
}
//# sourceMappingURL=AccessoryAddedSystem.js.map